import styled from "@emotion/styled";
import { Typography } from "@mui/material";
import { styled as materialStyled, DialogTitle } from "@mui/material";

export const UploadImage = styled("div")`
  height: 100px;
  width: 120px;
  backdrop-filter: blur(2px);
  background-color: rgba(255, 255, 255, 0.5);
  align-items: center;
  display: flex;
  justify-content: center;
`;

export const DocumentName = styled(Typography)`
  max-width: 177px;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  overflow: hidden;
  margin-top: 2px;
  overflow: hidden;
  padding-bottom: 1px;
  line-height: 1.2;
  text-align: center;
  height: auto;
  margin-bottom: 2px;
  word-break: break-all;
`;

export const DialogHeader = materialStyled(DialogTitle)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #e9ebec;
  margin-bottom: 16px;
  font-weight: 700;
  font-size: 24px;
`;
